export default __webpack_public_path__ + "e203ffb22cbe21a74f81cad5f63067f0.png";